export default __webpack_public_path__ + "static/media/why-mint.f0b7f6ba.png";